export enum EMasterDataType {
    OnSiteProtectionAndSealingType = 1,
    BumpingAndVibrationType,
    AirFlowType,
    ScolaTechnique,
    ScolaMaterial,
    DustLevel,
    DustTypeValue,
    AsbestosType,
    InvestigationScopeType,
    Humidification,
    HumidityWork,
    Catchment,
    EnvCollectiveMeanOfPrevention,
    PredefinedObservation
}